export const SeedToken = {
  fontFamily:
    "'Noto Sans TC', 'Roboto', 'Microsoft JhengHei', 'PingFang', 'sans-serif'",
  colorPrimary: '#2F3E73',
  colorTextBase: '#2B3F60',
  colorSuccess: '#4ADE84',
  colorError: '#FF4D4F',
  colorInfo: '#507ACD',
  colorWarning: '#F29500',
  controlHeight: 40,
  fontSize: 16,
  colorBgSpotlight: '#ffffff',
};

export const MapToken = {
  colorBorder: '#D0D5DD',
  colorErrorBg: '#FFF1F0',
  colorErrorBorder: SeedToken.colorError,
  colorSuccessBg: '#EFFFF5',
  colorSuccessBorder: SeedToken.colorSuccess,
  colorWarningBg: '#FFF4E1',
  colorWarningBorder: SeedToken.colorWarning,
  colorBgLayout: '#f0f1f2',
};

export const AliasToken = {
  colorTextDisabled: SeedToken.colorTextBase,
  colorBgContainerDisabled: '#F2F4F7',
  controlItemBgHover: '#F5FAFC',
  colorTextHeading: SeedToken.colorPrimary,
};

const commonColors = {
  RESERVED: '#B877F9',
  AVAILABLE: '#2068F6',
  CHARGING: '#6FD29F',
  UNAVAILABLE: '#FE7274',
  FAULTED: '#F19B5B',
};

export const CustomToken = {
  StationStatusColors: {
    0: SeedToken.colorError, // 暫停開放
    1: SeedToken.colorSuccess, // 開放
    2: '#98A2B3', // 長期歇業中
    3: '#5F90EF', // 選址中
    4: SeedToken.colorWarning, // 建設中
  },
  GunOperationalStatusColors: {
    ...commonColors,
    // RESERVED: '#B877F9', // 預約
    // AVAILABLE: '#2068F6', // 空閒
    // CHARGING: '#6FD29F', // 充電中
    // UNAVAILABLE: '#FE7274', // 禁用
    // FAULTED: '#F19B5B', // 故障
    OFFLINE: '#E4E7EC', // 離線
    HOGGING: '#F7C55D', // 佔用中
    // PROBLEM: '#F29500', // 警示
  },
  GunMaintenanceStatusColors: {
    ...commonColors,
    // RESERVED: '#B877F9',
    // AVAILABLE: '#2068F6',
    // CHARGING: '#6FD29F',
    // UNAVAILABLE: '#FE7274',
    // FAULTED: '#F19B5B',
    SUSPENDEDEVSE: '#A6D26F',
    PREPARING: '#F7F15D',
    FINISHING: '#DCAF52',
    SUSPENDEDEV: '#F7C55D',
    OFFLINE: '#98A2B3',
  },
};

export const Component = {
  Button: {
    colorText: SeedToken.colorPrimary,
    colorBorder: SeedToken.colorPrimary,
    borderRadius: 4,
    contentFontSize: 16,
    defaultShadow: 'none',
    primaryShadow: 'none',
    paddingBlock: 0,
    controlHeight: 32,
    paddingInline: 16,
    contentLineHeight: 1,
    borderColorDisabled: '#D0D5DD',
    colorTextDisabled: '#98A2B3',
  },
  Table: {
    headerColor: '#758199',
    headerBg: '#e2eff7',
    headerBorderRadius: 0,
    rowHoverBg: '#f5fafc',
    rowSelectedBg: '#ffffff',
    rowSelectedHoverBg: '#f5fafc',
    cellPaddingInline: 12,
  },
  Pagination: {
    borderRadius: 2,
    fontSize: 14,
    controlOutline: '#D0D5DD',
    itemSize: 32,
  },
  Select: {
    borderRadius: 6,
    optionFontSize: 16,
    optionHeight: 32,
    optionSelectedBg: '#F5FAFC',
    colorTextDisabled: '#acacac',
  },
  Modal: {
    titleColor: SeedToken.colorPrimary,
    colorText: SeedToken.colorPrimary,
    titleFontSize: 20,
    borderRadiusLG: 16,
    padding: 0,
  },
  Tag: {
    defaultBg: '#F6F8FA',
    defaultColor: '#98A2B3',
    colorBorder: '#98A2B3',
    borderRadiusSM: 2,
    colorInfo: '#5F90EF',
    colorInfoBg: '#F5FAFC',
    colorInfoBorder: '#5F90EF',
  },
  Tree: {
    nodeSelectedBg: '#e2eff7',
  },
  Cascader: {
    optionSelectedBg: '#e2eff7',
  },
  Form: {
    labelColor: '#758199',
  },
  Layout: {
    siderBg: '#ffffff',
    headerBg: '#f0f1f2',
    headerColor: SeedToken.colorTextBase,
    footerBg: '#f0f1f2',
    footerPadding: 20,
  },
  Menu: {
    itemHeight: 45,
    itemSelectedColor: '#ffffff',
    itemHoverBg: AliasToken.controlItemBgHover,
    itemColor: '#475467',
    groupTitleColor: '#98A2B3',
    groupTitleFontSize: 14,
    itemBorderRadius: 4,
    itemSelectedBg: SeedToken.colorPrimary,
    itemActiveBg: AliasToken.controlItemBgHover,
  },
  Tooltip: {
    paddingSM: 32,
    paddingXS: 16,
    fontSize: 14,
    colorTextLightSolid: '#475467',
  },
  Statistic: {
    titleFontSize: 14,
    contentFontSize: 24,
    colorTextDescription: '#758199',
  },
  Progress: {
    defaultColor: SeedToken.colorPrimary,
  },
};
